// Construcción del nombre de archivo para reportes escaneados.
// Formato: <fecha>_SEM<semana>_<tipoMantenimiento>_<planta>[_<sufijo>].<ext>
// Objetivo: nombres consistentes, ordenables por fecha y sin caracteres que
// rompan la clave de S3 (acentos, espacios, símbolos).

const slug = (value) =>
  (value || "")
    .toString()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // eliminar acentos/diacríticos
    .replace(/[^a-zA-Z0-9]+/g, "-") // no alfanumérico -> guion (colapsa repetidos)
    .replace(/^-+|-+$/g, "") // sin guiones al inicio/fin
    .toUpperCase();

// Parsea 'YYYY-MM-DD' como fecha local (evita el corrimiento de día que provoca
// new Date('YYYY-MM-DD') al interpretarse como UTC).
const parseFecha = (fechacreacion) => {
  if (fechacreacion instanceof Date) return fechacreacion;
  if (typeof fechacreacion === "string") {
    const m = fechacreacion.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (m) return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
    const d = new Date(fechacreacion);
    if (!Number.isNaN(d.getTime())) return d;
  }
  return new Date();
};

const startOfWeek = (date) => {
  const s = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  s.setDate(s.getDate() - s.getDay()); // domingo = inicio de semana
  return s;
};

const civilDay = (date) =>
  Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());

// Misma convención que la app (features/plan-anual/.../semana.js): la semana que
// contiene el 1 de enero es la semana 1; el año lo define el sábado de la semana.
export const getWeekNumber = (date) => {
  const start = startOfWeek(date);
  const end = new Date(start);
  end.setDate(end.getDate() + 6);
  const year = end.getFullYear();
  const first = startOfWeek(new Date(year, 0, 1));
  return 1 + Math.round((civilDay(start) - civilDay(first)) / (7 * 86400000));
};

const extensionDe = (originalName) => {
  const m = (originalName || "").match(/\.([a-zA-Z0-9]+)$/);
  return m ? m[1].toLowerCase() : "pdf";
};

export const buildScanReportFileName = ({
  fechacreacion,
  tipomantenimiento,
  nombreplanta,
  originalName,
} = {}) => {
  const fecha = parseFecha(fechacreacion);
  const yyyy = fecha.getFullYear();
  const mm = String(fecha.getMonth() + 1).padStart(2, "0");
  const dd = String(fecha.getDate()).padStart(2, "0");
  const semana = getWeekNumber(fecha);

  const tipo = slug(tipomantenimiento) || "SIN-TIPO";
  const planta = slug(nombreplanta) || "SIN-PLANTA";

  // ponytail: sufijo con la hora de subida (HHMMSS) para evitar que dos reportes
  // con misma fecha/semana/tipo/planta se sobrescriban en S3 (pérdida de datos).
  // Ceiling: colisión solo si se suben dos en el mismo segundo; no es un ID único.
  const ahora = new Date();
  const sufijo =
    String(ahora.getHours()).padStart(2, "0") +
    String(ahora.getMinutes()).padStart(2, "0") +
    String(ahora.getSeconds()).padStart(2, "0");

  return `${yyyy}-${mm}-${dd}_SEM${semana}_${tipo}_${planta}_${sufijo}.${extensionDe(
    originalName,
  )}`;
};

export default buildScanReportFileName;
